import React from 'react';
import styled from 'styled-components';
import { capitalize } from 'utils';

interface InlineErrorProps {
    message?: string;
    fontSize?: string;
    display?:
        | {
              message?: string;
          }
        | string
        | boolean;
    inline?: boolean;
    top?: string;
    right?: string;
}

interface InlineErrorStyleProps {
    fontSize?: string;
    top?: string;
    right?: string;
}

export const InlineError: React.FC<InlineErrorProps> = ({
    message = 'Ce champ est requis',
    fontSize,
    display,
    inline,
    top,
    right,
}) => {
    const ErrorComponent = inline ? InlineErrorInlineStyle : InlineErrorStyle;
    let errorMsg = '';
    if (display && typeof display === 'object' && display.message) {
        errorMsg = capitalize(display.message?.toLowerCase());
    } else if (typeof display === 'boolean' && display) {
        errorMsg = capitalize(message?.toLowerCase());
    }
    return display ? (
        <ErrorComponent fontSize={fontSize} top={top} right={right}>
            {errorMsg}
        </ErrorComponent>
    ) : null;
};

const InlineErrorStyle = styled.span<InlineErrorStyleProps>`
    position: absolute;
    top: ${(props) => (props.top ? props.top : '20px')};
    right: ${(props) => (props.right ? props.right : '4px')};
    color: ${(props) => props.theme.colors.red};
    font-size: ${(props) => props.fontSize || '0.9em'};
    text-transform: none;
    z-index: 2;
`;

const InlineErrorInlineStyle = styled.span<InlineErrorStyleProps>`
    color: ${(props) => props.theme.colors.red};
    font-size: ${(props) => props.fontSize || '0.9em'};
    text-transform: none;
`;
